/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_bb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When do price changes happen?`)
};

const es_f1_bb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuándo ocurren los cambios de precio?`)
};

const de_f1_bb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann finden Preisänderungen statt?`)
};

const nl_f1_bb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wanneer vinden prijswijzigingen plaats?`)
};

const fr_f1_bb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand les changements de prix ont-ils lieu ?`)
};

const it_f1_bb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando avvengono le variazioni di prezzo?`)
};

const pt_br2_f1_bb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando acontecem as mudanças de preço?`)
};

const pt_f1_bb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando acontecem as alterações de preço?`)
};

const ja_f1_bb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格変動はいつ発生しますか？`)
};

const zh_f1_bb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格变动什么时候发生？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_bb_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_bb_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_bb_faq2_q", locale)
	if (locale === "en") return en_f1_bb_faq2_q(inputs)
	if (locale === "es") return es_f1_bb_faq2_q(inputs)
	if (locale === "de") return de_f1_bb_faq2_q(inputs)
	if (locale === "nl") return nl_f1_bb_faq2_q(inputs)
	if (locale === "fr") return fr_f1_bb_faq2_q(inputs)
	if (locale === "it") return it_f1_bb_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_bb_faq2_q(inputs)
	if (locale === "pt") return pt_f1_bb_faq2_q(inputs)
	if (locale === "ja") return ja_f1_bb_faq2_q(inputs)
	return zh_f1_bb_faq2_q(inputs)
};